import React from 'react';
import Card from '@mui/material/Card';
import ToggleButton from './ArchiveToggleButton';
import ToggleButtonss from './ARchive';

interface ApplicationData {
  application: string;
  annualCost: string;
  costCenter: string;
  primaryContact: string;
  role: string;
  vendor: string;
  subscriptionModel: string;
  activeUsers: number;
  nextRenewal: string;
  riskScoring: 'low' | 'medium' | 'high' | 'critical';
  archive: 'Yes' | 'No';
  status: 'Active' | 'Inactive';
}

// Dummy data for the table
const dummyData: ApplicationData[] = [
  {
    application: 'Allscripts - Pro (Ephrata)',
    annualCost: '$958,500',
    costCenter: 'CC2001034',
    primaryContact: 'Kimberly',
    role: 'SDE',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '07/15/2023',
    riskScoring: 'low',
    archive: 'Yes',
    status: 'Active'
  },
  {
    application: 'Allscripts - Pro (Gettysburg)',
    annualCost: '$681,600',
    costCenter: 'CC2020334',
    primaryContact: 'Samar',
    role: 'Manager',
    vendor: 'Vendor',
    subscriptionModel: 'Per User',
    activeUsers: 15,
    nextRenewal: '09/01/2023',
    riskScoring: 'medium',
    archive: 'Yes',
    status: 'Active'
  },
  {
    application: 'Allscripts - TouchWorks',
    annualCost: '$2,076,750',
    costCenter: 'CC2001034',
    primaryContact: 'Halen',
    role: 'Manager',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '01/12/2024',
    riskScoring: 'high',
    archive: 'Yes',
    status: 'Active'
  },
  {
    application: 'AthenaHealth EHR- Ephrata',
    annualCost: '$1,034,600',
    costCenter: 'CC2001034',
    primaryContact: 'Kimberly',
    role: 'SDE',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 25,
    nextRenewal: '04/01/2024',
    riskScoring: 'low',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'AthenaHealth EHR- York',
    annualCost: '$683,700',
    costCenter: 'CC2001034',
    primaryContact: 'Samar',
    role: 'Manager',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 15,
    nextRenewal: '05/01/2024',
    riskScoring: 'low',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'Cerner(Ephrata)',
    annualCost: '$3,335,000',
    costCenter: 'CC2001034',
    primaryContact: 'Halen',
    role: 'Manager',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '01/12/2025',
    riskScoring: 'low',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'Cerner-1(Main)',
    annualCost: '$2,275,149',
    costCenter: 'CC2001034',
    primaryContact: 'Kimberly',
    role: 'SDE',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '01/12/2025',
    riskScoring: 'low',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'DrChrono',
    annualCost: '$181,050',
    costCenter: 'CC2001034',
    primaryContact: 'Samar',
    role: 'Manager',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '01/12/2025',
    riskScoring: 'low',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'EClinicalWorks-1',
    annualCost: '$860,750',
    costCenter: 'CC2031034',
    primaryContact: 'Halen',
    role: 'Manager',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '01/12/2025',
    riskScoring: 'critical',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'EClinicalWorks-2',
    annualCost: '$564,450',
    costCenter: 'CC2032035',
    primaryContact: 'Kimberly',
    role: 'SDE',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '11/12/2026',
    riskScoring: 'medium',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'GEMMS',
    annualCost: '$119,550',
    costCenter: 'CC2032036',
    primaryContact: 'Halen',
    role: 'Manager',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '01/12/2027',
    riskScoring: 'medium',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'NextGen-2',
    annualCost: '$581,490',
    costCenter: 'CC2001034',
    primaryContact: 'Kimberly',
    role: 'SDE',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '12/01/2027',
    riskScoring: 'low',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'NextGen-1',
    annualCost: '$577,500',
    costCenter: 'CC2001034',
    primaryContact: 'Kimberly',
    role: 'SDE',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 25,
    nextRenewal: '04/01/2024',
    riskScoring: 'low',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'Practice Fusion',
    annualCost: '$376,450',
    costCenter: 'CC2001034',
    primaryContact: 'Samar',
    role: 'Manager',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 15,
    nextRenewal: '05/01/2024',
    riskScoring: 'low',
    archive: 'No',
    status: 'Inactive'
  },
  {
    application: 'Prime Suite',
    annualCost: '$434,750',
    costCenter: 'CC2001034',
    primaryContact: 'Halen',
    role: 'Manager',
    vendor: 'Vendor',
    subscriptionModel: 'Annual',
    activeUsers: 300,
    nextRenewal: '01/12/2025',
    riskScoring: 'low',
    archive: 'No',
    status: 'Inactive'
  }
];
const getRiskScoringStyle = (
  riskScoring: ApplicationData['riskScoring']
): React.CSSProperties => {
  let backgroundColor;
  switch (riskScoring) {
    case 'low':
      backgroundColor = '#48df48';
      break;
    case 'medium':
      backgroundColor = '#e7e741';
      break;
    case 'high':
      backgroundColor = '#c52828';
      break;
    case 'critical':
      backgroundColor = '#e91c1c';
      break;
    default:
      backgroundColor = 'transparent';
  }

  return {
    margin: '2px',
    textAlign: 'center',
    backgroundColor,
    borderRadius: '1000px', // Adjust as needed
    padding: '5px 10px' // Adjust padding as needed
    // Add more styles here as needed
  };
};
// Styles for the table components
const tableContainerStyle: React.CSSProperties = {
  margin: 'auto',
  width: '98%',
  boxSizing: 'border-box',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'max-content',
  rowGap: '5px',
  columnGap: '5px',
  padding: '11px 0px 20px 4px',
  overflow: 'auto'
};

const tableStyle: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  backgroundColor: 'white'
};

const thStyle: React.CSSProperties = {
  fontSize: '1rem', // Changed from font-size to fontSize
  fontFamily: 'Public Sans, sans-serif', // Changed from font-family to fontFamily and removed the semicolon within the string
  fontWeight: '600', // Changed from font-weight to fontWeight
  backgroundColor: '#f2f2f2',
  textAlign: 'left',
  padding: '8px',
  border: '1px solid #ddd',
  maxWidth: '75px'
};

const tdStyle: React.CSSProperties = {
  fontSize: '0.875rem', // Changed from font-size to fontSize
  fontFamily: 'Public Sans, sans-serif', // Changed from font-family to fontFamily and removed the semicolon within the string
  fontWeight: '400', // Changed from font-weight to fontWeight

  padding: '8px',
  border: '1px solid #ddd'
};

const TableComponent: React.FC = () => (
  <Card>
    <div>
      <div style={tableContainerStyle}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Application
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Annual Cost
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Cost Center
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Primary Contact
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Role
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Vendor
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Subscription Model
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Active Users
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Next Renewal
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Risk Scoring
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis', // Adds ellipsis to overflow content
                  maxWidth: '70px'
                }}>
                Archive
              </th>
              <th
                style={{
                  ...thStyle,
                  whiteSpace: 'nowrap', // Keeps the text in a single line
                  overflow: 'hidden', // Hides overflow content
                  textOverflow: 'ellipsis' // Adds ellipsis to overflow content
                }}>
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {dummyData.map((data, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...tdStyle,
                    textAlign: 'left',
                    color: '#42c2eb',
                    whiteSpace: 'nowrap', // Keeps the text in a single line
                    overflow: 'hidden', // Hides overflow content
                    textOverflow: 'ellipsis', // Adds ellipsis to overflow content
                    maxWidth: '150px'
                  }}>
                  {data.application}
                </td>
                <td style={{...tdStyle, textAlign: 'right', color: 'grey'}}>
                  {data.annualCost}
                </td>
                <td style={{...tdStyle, textAlign: 'left', color: 'grey'}}>
                  {data.costCenter}
                </td>
                <td style={{...tdStyle, textAlign: 'left', color: 'grey'}}>
                  {data.primaryContact}
                </td>
                <td style={{...tdStyle, textAlign: 'left', color: 'grey'}}>
                  {data.role}
                </td>
                <td style={{...tdStyle, textAlign: 'left', color: 'grey'}}>
                  {data.vendor}
                </td>
                <td style={{...tdStyle, textAlign: 'left', color: 'grey'}}>
                  {data.subscriptionModel}
                </td>
                <td style={{...tdStyle, textAlign: 'left', color: 'grey'}}>
                  {data.activeUsers}
                </td>
                <td style={{...tdStyle, textAlign: 'left', color: 'grey'}}>
                  {data.nextRenewal}
                </td>
                <td
                  style={{
                    borderBottom: '1px solid rgb(205, 210, 215)',
                    borderRight: '1px solid rgb(205, 210, 215)'
                  }}>
                  <div style={getRiskScoringStyle(data.riskScoring)}>
                    {data.riskScoring}
                  </div>
                </td>
                <td
                  style={{
                    borderBottom: '1px solid rgb(205, 210, 215)',
                    borderRight: '1px solid rgb(205, 210, 215)'
                  }}>
                  <div style={{justifyContent: 'center', display: 'flex'}}>
                    <ToggleButton dat={data.archive} />
                  </div>
                </td>
                <td style={{...tdStyle, textAlign: 'left', color: 'grey'}}>
                  <div style={{justifyContent: 'center', display: 'flex'}}>
                    <ToggleButtonss dat={data.status} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </Card>
);

export default TableComponent;
